const state = {
  details: {},
  firstName: '',
  phoneNumber: '',
  addressLine1: '',
  addressLine2: '',
  postalCode: '',
  city: '',
  lastName: '',
  country: false,
  state: false,
  userId: 0,
  userImageUrl: '',
  game: {
    id: 0,
    players: []
  },
  tracking: true
}

// getters
const getters = {
  getTracking (state) {
    return state.tracking
  },
  getUserId (state) {
    return state.userId
  },
  getFirstName (state) {
    return state.firstName
  },
  getLastName (state) {
    return state.lastName
  },
  getCountry (state) {
    return state.country
  },
  getState (state) {
    return state.state
  },
  getGameAllPlayers (state) {
    return state.game.players
  },
  getGameId (state) {
    return state.game.id
  },
  getUserDetails (state) {
    return state.details
  },
  userFullName (state) {
    return state.firstName + ' ' + state.lastName
  },
  avatar (state) {
    if (state.userImageUrl && state.userImageUrl.includes('playerservice/user')) {
      return process.env.API_URL + state.userImageUrl
    } else {
      return state.userImageUrl
    }
  },
  avatarLetters () {
    if (typeof state.details.firstName === 'undefined') {
      return ''
    } else {
      return state.details.firstName.charAt(0) + ' ' + state.details.lastName.charAt(0)
    }
  },
  getPhone (state) {
    return state.phoneNumber
  },
  getAddressLine1 (state) {
    return state.addressLine1
  },
  getAddressLine2 (state) {
    return state.addressLine2
  },
  getCity (state) {
    return state.city
  },
  getPostalCode (state) {
    return state.postalCode
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  setUserId (state, id) {
    state.userId = id
  },
  setFirstName (state, detail) {
    state.firstName = detail
  },
  setLastName (state, detail) {
    state.lastName = detail
  },
  setCountry (state, detail) {
    state.country = detail
  },
  setState (state, detail) {
    state.state = detail
  },
  setUserDetails (state, details) {
    state.details = details
  },
  setAvatar (state, newValue) {
    state.userImageUrl = newValue
  },
  setPhone (state, newValue) {
    state.phoneNumber = newValue
  },
  setAddressLine1 (state, newValue) {
    state.addressLine1 = newValue
  },
  setAddressLine2 (state, newValue) {
    state.addressLine2 = newValue
  },
  setCity (state, newValue) {
    state.city = newValue
  },
  setPostalCode (state, newValue) {
    state.postalCode = newValue
  },
  setTracking (state, newVal) {
    state.tracking = newVal
  },
  recordTimeStart (state, msg) {
    console.log('Record Time Start:', msg)
  },
  recordTimeEnd (state, msg) {
    console.log('Record time End: ', msg)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js